import { type ImgHTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';

/**
 * EmptyCircle size variants.
 *
 * | size | px   | usage                      |
 * |------|------|----------------------------|
 * | `sm` | 30px | Card headers, inline icons |
 * | `md` | 40px | Default size               |
 * | `lg` | 50px | Featured sections          |
 */
const emptyCircleVariants = cva('rounded-full overflow-hidden flex-shrink-0 bg-border', {
  variants: {
    size: {
      sm: 'size-[30px]',
      md: 'size-10',
      lg: 'size-[50px]',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export type EmptyCircleProps = ImgHTMLAttributes<HTMLImageElement> & VariantProps<typeof emptyCircleVariants>;

export { emptyCircleVariants };
